<template>
	<div class="toast_overlay" v-show="isVisible" @click="handleClose">
		<div class="toast_wrapper">
			<div class="title heading_5">{{ title }}</div>
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		isVisible: {
			type: Boolean,
			required: true
		},
		title: {
			type: String,
			required: true
		},
		onClose: {
			type: Function
		}
	},
	methods: {
		handleClose() {
			if (this.onClose) {
				this.onClose()
			}
		}
	}
}
</script>

<style scope>
.toast_overlay {
	position: fixed;
	overflow: auto;
	width: 100%;
	max-width: 768px;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.3);
	z-index: var(--zIndex-dim);
	transition: opacity 0.3s ease;
}

.toast_wrapper {
	width: 100%;
	position: fixed;
	bottom: 0;
	background-color: var(--gray-scale-12);
	padding: 24px 12px;
	border-top-left-radius: 16px;
	border-top-right-radius: 16px;
	transition: transform 0.3s ease;
	animation: bottom forwards 0.4s;
}

@keyframes bottom {
	0% {
		bottom: -100%;
	}

	100% {
		bottom: 0%;
	}
}

.toast_wrapper>.title {
	text-align: center;
	white-space: pre-line;
	margin-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/ai/AiToast.vue